
import CourseIndex from '../components/courses/CourseIndex.vue';
import Vue from 'vue';

Vue.component('course-index', CourseIndex);

export default Vue.extend({});
